<template>
  <span>
    <b-form-select
      v-model="writeMethod.sourceCell"
      :options="dataGrid_cellsSelect(sourceGrid)"
      size="sm"
      @change="updateAction"
    />

    <span>to added row cell</span>
    <b-form-select
      v-model="writeMethod.targetCell"
      :options="dataGrid_cellsSelect(action.gridId)"
      size="sm"
      @change="updateAction"
    />
    <span></span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'eventBus',
    'writeMethod',
    'writeMethodIdx',
    'action',
    'actionIdx',
    'sourceGrid',
  ],
  computed: {
    ...mapGetters(['dataGrid_cellsSelect']),
  },
  methods: {
    updateAction() {
      this.eventBus.$emit(
        'setAction',
        Object.assign({}, this.action),
        this.actionIdx
      )
    },
  },
}
</script>
